import { CoreBlocks } from '@faustwp/blocks';
import CoreGroup from './CoreGroup/CoreGroup';
import CoreColumns from './CoreColumns/CoreColumns';
import CoreColumn from './CoreColumn/CoreColumn';
import CoreImage from './CoreImage/CoreImage';
import CoreButtons from './CoreButtons/CoreButtons';
import CoreButton from './CoreButton/CoreButton';
import CoreHeading from './CoreHeading/CoreHeading';
import CoreParagraph from './CoreParagraph/CoreParagraph';
import CoreCover from './CoreCover/CoreCover';
import CoreTable from './CoreTable/CoreTable';
import CoreList from './CoreList/CoreList';
import CoreSeparator from './CoreSeparator/CoreSeparator';
import AcfCard from './AcfCard/AcfCard';
import AcfAccordion from './AcfAccordion/AcfAccordion';
import AcfFeature from './AcfFeature/AcfFeature';
import AcfBillboard from './AcfBillboard/AcfBillboard';
import AcfLeadGenForm from './AcfLeadGenForm/AcfLeadGenForm';
import AcfLogoFarm from './AcfLogoFarm/AcfLogoFarm';
import AcfStyledList from './AcfStyledList/AcfStyledList';
import AcfStats from './AcfStats/AcfStats';
import AcfProductComparisonCard from './AcfProductComparisonCard/AcfProductComparisonCard';
import AcfFeatureComparison from './AcfFeatureComparison/AcfFeatureComparison';
import AcfTabs from './AcfTabs/AcfTabs';
import AcfArtDirectionImage from './AcfArtDirectionImage/AcfArtDirectionImage';
import AcfShadow from './AcfShadow/AcfShadow';
import AcfAppBadges from './AcfAppBadges/AcfAppBadges';
import AcfStripe from './AcfStripe/AcfStripe';
import AcfCarousel from './AcfCarousel/AcfCarousel';
import AcfLottie from './AcfLottie/AcfLottie';
import AcfExpandableCard from './AcfExpandableCard/AcfExpandableCard';
import AcfContainer from './AcfContainer/AcfContainer';
import AcfForm from './AcfForm/AcfForm';
import AcfInput from './AcfInput/AcfInput';
import AcfSelect from './AcfSelect/AcfSelect';
import AcfFieldset from './AcfFieldset/AcfFieldset';
import AcfFilteredList from './AcfFilteredList/AcfFilteredList';
import AcfFilteredListItem from './AcfFilteredListItem/AcfFilteredListItem';

export default {
  CoreGroup: CoreGroup,
  CoreColumns: CoreColumns,
  CoreColumn: CoreColumn,
  CoreImage: CoreImage,
  CoreButtons: CoreButtons,
  CoreButton: CoreButton,
  CoreHeading: CoreHeading,
  CoreParagraph: CoreParagraph,
  CoreCover: CoreCover,
  CoreTable: CoreTable,
  CoreCode: CoreBlocks.CoreCode,
  CoreQuote: CoreBlocks.CoreQuote,
  CoreSeparator: CoreSeparator,
  CoreList: CoreList,
  AcfCard: AcfCard,
  AcfAccordion: AcfAccordion,
  AcfFeature: AcfFeature,
  AcfBillboard: AcfBillboard,
  AcfLeadGenForm: AcfLeadGenForm,
  AcfLogoFarm: AcfLogoFarm,
  AcfStyledList: AcfStyledList,
  AcfStats: AcfStats,
  AcfProductComparisonCard: AcfProductComparisonCard,
  AcfFeatureComparison: AcfFeatureComparison,
  AcfTabs: AcfTabs,
  AcfArtDirectionImage: AcfArtDirectionImage,
  AcfShadow: AcfShadow,
  AcfAppBadges: AcfAppBadges,
  AcfStripe: AcfStripe,
  AcfCarousel: AcfCarousel,
  AcfLottie: AcfLottie,
  AcfExpandableCard: AcfExpandableCard,
  AcfContainer: AcfContainer,
  AcfForm: AcfForm,
  AcfInput: AcfInput,
  AcfSelect: AcfSelect,
  AcfFieldset: AcfFieldset,
  AcfFilteredList: AcfFilteredList,
  AcfFilteredListItem: AcfFilteredListItem,
};